/**
 * Route component for `/place/:slug` (community-submitted places).
 *
 * The detail UI itself is the same as `/park/:id` — reviews,
 * check-ins, busy reports, breadcrumb, freshness signal, JSON-LD
 * LocalBusiness schema, OG/Twitter cards — so we delegate to the
 * shared `ParkDetail` page. ParkDetail reads `useParams().slug` and
 * computes the unified place id (`sp_<slug>`) automatically, then
 * branches on `park.source === "community"` to:
 *   - skip Google-only sections (Google photos carousel + Google
 *     reviews + Google rating + Google hours)
 *   - render the "Community Submitted" pill
 *   - mark the page indexable (vs. /park/:id which is noindex)
 *
 * Keeping this as a separate route component (instead of just
 * pointing the route at `<ParkDetail />`) so future per-page logic
 * (different breadcrumbs, banner, etc.) has a clean home.
 */
import React from "react";
import ParkDetail from "./ParkDetail";

const SubmittedPlaceDetail = () => <ParkDetail />;

export default SubmittedPlaceDetail;
